import React from 'react';
import { Link } from 'react-router-dom';
import profileImg from '../assets/profile-pic.jpg';

const links = [
  { label: 'Cursos 📚', to: '/', internal: true },
  { label: 'Agendar Turno 📅', url: 'https://wa.me/5491132092909?text=Hola,%20quiero%20un%20turno%20con%20la%20Dra%20Fioreella!', internal: false },
];

export default function Linktree() {
  return (
    <div className="linktree-container">
      <div className="linktree-content">
        <img
          src={profileImg}
          alt="Dra. Fioreella Isamar"
          className="profile-img"
        />
        <h1>Dra. Fioreella Isamar</h1>
        <p className="subtitle">Contagiando mi pasión</p>

        <div className="buttons">
          {links.map((link, i) =>
            link.internal ? (
              <Link key={i} to={link.to} className="link-btn" id="courses-link">
                {link.label}
              </Link>
            ) : (
              <a key={i} href={link.url} className="link-btn" target="_self" rel="noopener noreferrer" id="whatsapp-link">
                {link.label}
              </a>
            )
          )}
        </div>
      </div>
    </div>
  );
}
